import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export const SectionCard = ({ title, description, icon: Icon, children, className = '' }) => {
  return (
    <Card className={`shadow-lg border border-border/80 rounded-2xl ${className}`} data-testid="section-card">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-4">
          {Icon && (
            <div className="p-3 bg-primary/10 rounded-xl">
              <Icon className="h-7 w-7 text-primary" strokeWidth={1.8} />
            </div>
          )}
          <div>
            <CardTitle className="text-2xl md:text-3xl font-extrabold tracking-tight text-secondary normal-case">
              {title}
            </CardTitle>
            {description && (
              <CardDescription className="mt-1.5">{description}</CardDescription>
            )}
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        {children}
      </CardContent>
    </Card>
  );
};